<template>
  <main>
    <div class="info">
      <div >
        <h3>昵称</h3>
        <p>{{userInfo.userName}}</p>
      </div>
      <div>
        <h3>头像</h3>
        <img :src="userInfo.headImg" alt="">
      </div>
      <div>
        <h3>电话</h3>
        <!-- <p>{{userInfo.phoneNum}}</p> -->
        <input type="text" placeholder="暂未绑定 去绑定" v-model="userInfo.phoneNum" @click="link('/phone')" v-bind:disabled="userInfo.phoneNum">
      </div>

    </div>
  </main>
</template>

<script>
import API from "../api/index";
import { StringUtil, Cookies } from '../util/index'


    export default {
        name: "userinfo",

        data() {
          return {
            userInfo: [],
          }
        },

        mounted() {
          var _this=this;

          this.$http({
          method:'post',
          data: {
            userId:Cookies.get("userId"),
            userType:Cookies.get("userType"),

          },
          url:API.loadUserInfo_url
              }).then(function(resp){
                  console.log(resp.data);
                   _this.userInfo=resp.data.data;
                }).catch(resp => {
                  console.log('请求失败：'+resp.status+','+resp.statusText);
          });
        },

        methods: {
            
            link(url) {
              console.log(this.userInfo);
              if(this.userInfo.phoneNum) {
                return
              }
                this.$router.push(url)
            }
        },
        
    }
</script>

<style scoped>
  .info {
    margin: 20px;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
    padding: 0 20px;
  }

  .info div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    font-size: 22px;
  }

  .info div + div {
    border-top: 1px solid #ddd;
  }

  .info div h3 {
    color: #333;
    font-size: 30px;
  }

  .info div p {
    color: #666;
    font-size: 30px;
  }

  .info div input {
    font-size: 30px;
    text-align: right;
  }

  .info div img {
    width: 60px;
  }

 input:disabled {
     background-color : #fff; 
     color: #666; 
     opacity:1; 
     -webkit-text-fill-color:#666;   
     -webkit-opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/userinfo.vue